import { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PATH_URL } from 'src/helpers/path'
import { preserveUrlParams } from 'src/helpers/preserveUrlParams'
import { splitFullName } from 'src/helpers/tool'
import { UsePartnerFullNameReturn } from './types'
import { validatePartnerFullName } from './utils'

export const usePartnerFullName = (): UsePartnerFullNameReturn => {
  const history = useHistory()
  const [fullName, setFullName] = useState('')
  const [partnerFullName, setPartnerFullName] = useState('')
  const [error, setError] = useState('')

  const handleFullNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFullName(e.target.value)
      if (error) setError('')
    },
    [error]
  )

  const handlePartnerFullNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setPartnerFullName(e.target.value)
      if (error) setError('')
    },
    [error]
  )

  const handleSubmit = useCallback(() => {
    const validation = validatePartnerFullName(fullName, partnerFullName)
    if (!validation.isValid) {
      setError(validation.error)
      return
    }
    try {
      const collectionsQuizEntry = JSON.parse(localStorage.getItem('collectionsQuizEntry') || '{}')
      const [firstName, lastName] = splitFullName(fullName)
      const [partnerFirstName, partnerLastName] = splitFullName(partnerFullName)
      collectionsQuizEntry.customerInfo = {
        firstName: firstName,
        lastName: lastName,
        partnerName: partnerFullName.trim(),
        partnerFirstName: partnerFirstName,
        partnerLastName: partnerLastName,
        emailAddress: collectionsQuizEntry.customerInfo?.emailAddress || collectionsQuizEntry.email || '',
      }
      localStorage.setItem('collectionsQuizEntry', JSON.stringify(collectionsQuizEntry))

      // Use preserveUrlParams to maintain query parameters
      const nextUrl = preserveUrlParams(PATH_URL.COLLECTIONS_QUIZ_DATE_PICKER)
      history.push(nextUrl)
    } catch (err) {
      setError('Failed to save data. Please try again.')
    }
  }, [fullName, partnerFullName, history])

  const validation = validatePartnerFullName(fullName, partnerFullName)
  const isValid = validation.isValid

  return {
    fullName,
    partnerFullName,
    error,
    isValid,
    handleFullNameChange,
    handlePartnerFullNameChange,
    handleSubmit,
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && isValid) {
        e.preventDefault()
        handleSubmit()
      }
    },
  }
}
